import { HelmetDexteel } from "@dexteel/mesf-core";
import { SummaryByDateRangeReport } from "./components/SummaryByDateRangeReport";

export const SummaryByDateRangePage = () => (
	<>
		<HelmetDexteel title="Summary By Date Range" />
		<SummaryByDateRangeReport />
	</>
);
